import { render, staticRenderFns } from "./GoogleLoginButton.vue?vue&type=template&id=50b19236&scoped=true&"
import script from "./GoogleLoginButton.vue?vue&type=script&lang=ts&"
export * from "./GoogleLoginButton.vue?vue&type=script&lang=ts&"
import style0 from "./GoogleLoginButton.vue?vue&type=style&index=0&id=50b19236&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b19236",
  null
  
)

export default component.exports